import { useState } from "react";
import {
  Menu,
  LayoutDashboard,
  LogOut,
  PencilLine,
  NotepadText,
} from "lucide-react"; // Icons for open/close
import { getAuth, signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import style from "../mainlayout/Mainlayout.css";

const Sidebar = () => {
  const auth = getAuth();
  const navigate = useNavigate();
  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/");
      let res = await fetch(`${process.env.REACT_APP_NODEURL}/logout`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
      });
      window.history.pushState(null, null, window.location.href);
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  useEffect(() => {
    const handlePopState = () => {
      window.history.pushState(null, null, window.location.href);
    };

    window.history.pushState(null, null, window.location.href);
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);
  return (
    <div className="fixed top-0 left-0 h-full w-20 sidebar text-white shadow-lg transition-transform transform">
      {/* Sidebar Header */}
      <div className="flex justify-center items-center p-4 border-b border-gray-800">
        <button className="hover:text-gray-400">
          <Menu size={24} />
        </button>
      </div>

      {/* Sidebar Navigation */}
      <nav className="p-4">
        <ul className="space-y-6">
          <li
            onClick={() => navigate("/dashboard")}
            className="group relative p-3 flex justify-center rounded-lg hover:bg-[#292A3A] transition-colors"
          >
            <LayoutDashboard size={28} />
            <span className="absolute left-20 top-1/2 -translate-y-1/2 bg-purple-900 text-white text-sm px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-10">
              Dashboard
            </span>
          </li>

          <li
            onClick={() => navigate("/createPlan")}
            className="group relative p-3 flex justify-center rounded-lg hover:bg-[#292A3A] transition-colors"
          >
            <PencilLine size={28} />
            <span className="absolute left-20 top-1/2 -translate-y-1/2 bg-purple-900 text-white text-sm px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-10">
              Create Plan
            </span>
          </li>

          <li
            onClick={() => navigate("/goals")}
            className="group relative p-3 flex justify-center rounded-lg hover:bg-[#292A3A] transition-colors"
          >
            <NotepadText size={28} />
            <span className="absolute left-20 top-1/2 -translate-y-1/2 bg-purple-900 text-white text-sm px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-10">
              Goals
            </span>
          </li>

          <li
            onClick={handleLogout}
            className="group relative p-3 flex justify-center rounded-lg hover:bg-[#292A3A] transition-colors"
          >
            <LogOut size={28} />
            <span className="absolute left-20 top-1/2 -translate-y-1/2 bg-purple-900 text-white text-sm px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-10">
              Logout
            </span>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
